// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_p7-0";